var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMention(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40689_49381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1959 9.99663V6.80212M13.1959 9.99663C13.1959 5.87605 6.80372 5.87605 6.80372 9.99663C6.80372 14.1252 13.1959 14.0796 13.1959 9.99663ZM13.1959 9.99663C13.1959 13.9918 17.1911 13.9918 17.1911 9.99663C17.1911 6.02627 13.971 2.80859 9.99982 2.80859C6.02867 2.80859 2.80859 6.02627 2.80859 9.99663C2.80859 13.9662 6.02867 17.1839 9.99982 17.1839C11.3382 17.251 13.1464 16.8475 14.615 15.7208",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40689_49381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMention);
export default __webpack_public_path__ + "static/media/mention.3c0c0a0b.svg";
export { ForwardRef as ReactComponent };